'use client';

import { useEffect, useState } from 'react';
import Image from 'next/image';
import { BlogListingSection, Breadcrumbs, Header, SponsoredBannersProvider } from '@/components';
import type { Store } from '@/lib/types/stores';

const API_BASE = process.env.NEXT_PUBLIC_API_BASE_URL || 'http://localhost:4000';

export default function BlogPage() {
  const [stores, setStores] = useState<Store[]>([]);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API_BASE}/api/stores`, { cache: 'no-store' });
        if (res.ok) {
          const data = await res.json();
          if (data?.stores) setStores(data.stores);
        }
      } catch {
        // ignore
      }
    })();
  }, []);

  return (
    <SponsoredBannersProvider>
      <div className="min-h-screen">
        <Header stores={stores} base={API_BASE} />

        <main className="home-page space-y-16 px-4 pb-16 sm:space-y-24 sm:px-8">
          <section className="relative mt-4 overflow-hidden sm:mt-6" aria-labelledby="blog-hero-heading">
            <div className="mx-auto w-full">
              <div className="relative w-full overflow-hidden rounded-2xl bg-brand-100 sm:rounded-2xl">
                <div className="pointer-events-none absolute inset-0 z-0">
                  <Image
                    src="/media/pages/hero-bg-image.webp"
                    alt=""
                    fill
                    priority
                    className="object-cover object-center opacity-[0.05]"
                    sizes="100vw"
                    aria-hidden
                  />
                </div>
                <div className="pointer-events-none absolute inset-0 z-[1] bg-brand-100/10" aria-hidden />

                <div className="relative z-[2] flex flex-col gap-6 p-4 sm:gap-8 sm:p-6 lg:p-8">
                  <div className="min-w-0 flex-1">
                    <Breadcrumbs items={[{ label: 'Blog' }]} tone="onDark" />

                    <h1
                      id="blog-hero-heading"
                      className="text-h2-mobile font-bold leading-tight text-white lg:text-h2-desktop"
                    >
                      Cannabis News & Insights
                    </h1>

                    <p className="mt-4 max-w-[52rem] text-body-16-desktop font-normal leading-relaxed text-white/90">
                      Industry trends, product guides, and what our team is reading on. New to cannabis or
                      a longtime fan, you&apos;ll find something worth your time.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <BlogListingSection />
        </main>
      </div>
    </SponsoredBannersProvider>
  );
}
